// Free gifts, following the colour. Also the bundle's included row, which
// asks for this same file: snippets/nextdev-pdp-bundle-selector.liquid.
//
// The gifts in this block are pictures and names, not products, so there is no
// variant to read a picture off. The tie is the file name: the picture for a
// colour is the base file with the colour on the end, beige-bed.png and
// beige-bed-forest-green.png beside it.
//
// Liquid cannot ask whether a file is there, so the swap is done here. The
// candidate is fetched first and only put in place once it answers; one that
// does not leaves the first picture where it is and is not asked for again.
// That way a colour nobody uploaded shows the base picture rather than a
// broken frame, which is what a missing file would otherwise draw.
//
// The choice is read the way every other snippet beside the product column
// reads it: the nextdev:pdp:variant event as it changes, and the section's own
// nextdevPdpOptions() for what is already picked on load. Both hand over the
// options keyed by the option's own name, so the colour is found by name and
// never by position.
(function () {
  'use strict';

  // A page carrying both the free gifts and the bundle asks for this file
  // twice, and a script tag named twice runs twice. Once is enough: every
  // following picture on the page is found by its attribute, whichever block
  // drew it.
  if (window.nextdevFollowColour) return;
  window.nextdevFollowColour = true;

  // Shopify's handleize, as far as a file name needs it: lower case, spaces
  // and slashes to dashes, everything else dropped. 'Forest Green' is
  // forest-green and 'XS/S' is xs-s.
  function handleize(value) {
    return String(value)
      .toLowerCase()
      .trim()
      .replace(/[\s/_]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-{2,}/g, '-')
      .replace(/^-|-$/g, '');
  }

  // Every colour the product offers, not just the one picked, read off the
  // option buttons the section already drew. Needed because a base picture is
  // often one of the colours itself rather than a neutral one, and the colour
  // on its end has to come off before another goes on. Knowing the list is
  // what keeps that from being a guess: only a value this product actually
  // offers is ever treated as a colour and cut.
  function coloursIn(root) {
    var out = [];
    if (!root) return out;
    var groups = root.querySelectorAll('[data-option-name]');
    for (var g = 0; g < groups.length; g++) {
      var name = groups[g].getAttribute('data-option-name') || '';
      if (!/^colou?r$/i.test(name.trim())) continue;
      var values = groups[g].querySelectorAll('[data-value]');
      for (var v = 0; v < values.length; v++) {
        var handle = handleize(values[v].getAttribute('data-value'));
        if (handle && out.indexOf(handle) === -1) out.push(handle);
      }
    }
    return out;
  }

  // The stem with a colour of this product's own taken off the end, if it
  // carries one. The longest match wins, so 'sand-gray' is not mistaken for
  // 'gray' where both are offered.
  function trimColour(stem, colours) {
    var best = '';
    for (var i = 0; i < colours.length; i++) {
      var tail = '-' + colours[i];
      if (stem.length > tail.length &&
          stem.slice(-tail.length) === tail &&
          colours[i].length > best.length) {
        best = colours[i];
      }
    }
    return best ? stem.slice(0, stem.length - best.length - 1) : stem;
  }

  // Colour under any of the names a shop writes it with. Size and the rest are
  // not asked about: one picture per colour is the whole of the feature.
  function colourOf(picked) {
    if (!picked) return '';
    var names = Object.keys(picked);
    for (var i = 0; i < names.length; i++) {
      if (/^colou?r$/i.test(names[i].trim())) return picked[names[i]];
    }
    return '';
  }

  function candidate(base, handle, colours) {
    var dot = base.lastIndexOf('.');
    if (dot < 1) return '';
    var stem = trimColour(base.slice(0, dot), colours);
    return stem + '-' + handle + base.slice(dot);
  }

  // Remembered per image: what it started as, so a colour with no file of its
  // own goes back rather than keeping the last one that had one.
  function remember(img) {
    if (!img.nextdevGiftBase) {
      img.nextdevGiftBase = { src: img.getAttribute('src') || '', srcset: img.getAttribute('srcset') || '' };
    }
    return img.nextdevGiftBase;
  }

  function restore(img) {
    var was = remember(img);
    if (img.getAttribute('src') !== was.src) img.setAttribute('src', was.src);
    // The srcset goes back with it. Left holding the old one a browser draws
    // the old picture whatever the src says.
    if (was.srcset) img.setAttribute('srcset', was.srcset);
    else img.removeAttribute('srcset');
  }

  function show(img, url) {
    remember(img);
    img.setAttribute('src', url);
    img.removeAttribute('srcset');
  }

  function follow(picked) {
    var images = document.querySelectorAll('img[data-nextdev-gift-follow]');
    if (!images.length) return;

    var handle = handleize(colourOf(picked));

    Array.prototype.forEach.call(images, function (img) {
      var base = img.getAttribute('data-gift-base') || '';
      if (!base) return;

      if (!handle) {
        restore(img);
        return;
      }

      if (!img.nextdevGiftColours) {
        var root = img.closest ? img.closest('[data-nextdev-pdp]') : null;
        img.nextdevGiftColours = coloursIn(root);
      }

      var url = candidate(base, handle, img.nextdevGiftColours);
      if (!url) {
        restore(img);
        return;
      }

      var width = img.getAttribute('data-gift-width');
      if (width) url += (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;

      // Asked once per url and the answer kept, so moving back and forth
      // between colours does not fetch the same file again.
      if (!img.nextdevGiftSeen) img.nextdevGiftSeen = {};
      var seen = img.nextdevGiftSeen;

      if (seen[url] === false) {
        restore(img);
        return;
      }
      if (seen[url] === true) {
        show(img, url);
        return;
      }

      var probe = new Image();
      probe.onload = function () {
        seen[url] = true;
        // The colour may have moved on while this was in the air; only put it
        // in place if it is still the one being asked for.
        if (img.getAttribute('data-gift-wanted') === url) show(img, url);
      };
      probe.onerror = function () {
        seen[url] = false;
        if (img.getAttribute('data-gift-wanted') === url) restore(img);
      };
      img.setAttribute('data-gift-wanted', url);
      probe.src = url;
    });
  }

  // The theme editor reloads a section and boot runs again; the listener is
  // taken on once, or every reload would add another and each change would be
  // followed that many times over.
  var listening = false;

  function boot() {
    if (!document.querySelector('img[data-nextdev-gift-follow]')) return;

    if (!listening) {
      document.addEventListener('nextdev:pdp:variant', function (event) {
        follow(event && event.detail ? event.detail.options : null);
      });
      listening = true;
    }

    // What is already picked when the page settles. The section publishes it
    // on its own root, so the first draw matches the buttons without waiting
    // for a change that may never come. Found from the picture outwards rather
    // than off the document, the way the gift picker does it: a page carrying
    // two product columns has two roots and the near one is the right one.
    var first = document.querySelector('img[data-nextdev-gift-follow]');
    var section = first && first.closest ? first.closest('[data-nextdev-pdp]') : null;
    if (section && typeof section.nextdevPdpOptions === 'function') {
      follow(section.nextdevPdpOptions());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
